import React from 'react';
import { Clock, CheckCircle, XCircle } from 'lucide-react';

export default function StatsOverview({ stats }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      {/* Pending Requests */}
      <div className="bg-white rounded-lg shadow-sm p-6 border-l-4 border-orange-500">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600 mb-1">Pending Requests</p>
            <p className="text-3xl font-bold text-gray-900">{stats?.pendingRequests}</p>
          </div>
          <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center">
            <Clock className="w-6 h-6 text-orange-600" />
          </div>
        </div>
        <p className="text-xs text-gray-500 mt-3">Awaiting your decision</p>
      </div>
      {/* Processed Today */}
      <div className="bg-white rounded-lg shadow-sm p-6 border-l-4 border-blue-500">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600 mb-1">Processed Today</p>
            <p className="text-3xl font-bold text-gray-900">{stats?.processedToday}</p>
          </div>
          <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
            <CheckCircle className="w-6 h-6 text-blue-600" />
          </div>
        </div>
        <p className="text-xs text-gray-500 mt-3">Decisions made today</p>
      </div>
      {/* Total Cancelled */}
      <div className="bg-white rounded-lg shadow-sm p-6 border-l-4 border-gray-500">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600 mb-1">Total Cancelled</p>
            <p className="text-3xl font-bold text-gray-900">{stats?.totalCancelled}</p>
          </div>
          <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center">
            <XCircle className="w-6 h-6 text-gray-600" />
          </div>
        </div>
        <p className="text-xs text-gray-500 mt-3">All-time cancellations</p>
      </div>
    </div>
  );
}